/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc10Inputs */

const en_fc_tut_sc10 = /** @type {(inputs: Fc_Tut_Sc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle trim type`)
};

/**
* | output |
* | --- |
* | "Toggle trim type" |
*
* @param {Fc_Tut_Sc10Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc10 = /** @type {((inputs?: Fc_Tut_Sc10Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc10Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc10(inputs)
});
export { fc_tut_sc10 as "fc.tut.sc10" }